import PropTypes from 'prop-types';

const SectionDescriptionBody = (props) => {
  const { data } = props;
  const { description } = data;

  return <div className="text-center text-up-01 mb-2xh">{description}</div>;
};

SectionDescriptionBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default SectionDescriptionBody;
